export default __webpack_public_path__ + "static/media/jesus-6.e4c63fc1.png";